import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';
import React from 'react'
import Axios from "axios";


export class MapContainer extends React.Component {



    componentDidMount() {
        this.geocode(this.props.location)
    }

    geocode(location) {
        // var location = '22 Main st Boston MA'
        // this.props.getAddress(location)
        let res = Axios.get('https://maps.googleapis.com/maps/api/geocode/json',{
                params: {
                        address: location,
                        key: 'AIzaSyBArzvnPkV9qwn_dYLzAstCufarYdo4S2U'
                    }
                }
        )
    
        .then(response => {
            var formattedAddress = response.data.results[0].geometry.location;
            this.setState({key: formattedAddress})
            })
    
    }

    render() {

        const mapStyles = {
            width: '50%',
            height: '50%',
          };

        return ( 
            <Map
            google={this.props.google}
            zoom={8}
            style={mapStyles}
            initialCenter={{lat: 0, lng:0}}
            >
            <Marker position= {{lat: 0, lng:0}}/>
            </Map>
        )
    }

}

export default GoogleApiWrapper({
    apiKey: 'AIzaSyBArzvnPkV9qwn_dYLzAstCufarYdo4S2U'
  })(MapContainer);
